<app-notification style="z-index: 100"></app-notification>
<div *ngIf="quiz.id !== undefined">
    <app-answers [hidden]="quiz.status['question'] == 0 || quiz.status['status'] == 'End'" *ngIf="quiz.status['status'] == 'Live' || quiz.status['status'] == 'End'"></app-answers>
    <app-splash [hidden]="quiz.status['status'] == 'Live' && quiz.status['question'] > 0"></app-splash>
</div>